import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function RefundPolicy() {
  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid="refund-page">
      <Header />
      <main className="flex-1">
        <section className="bg-primary text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 md:py-14">
            <p className="text-accent text-sm font-semibold tracking-wider uppercase mb-3">Legal</p>
            <h1 className="font-display text-4xl md:text-5xl font-bold">Refund Policy</h1>
            <p className="text-white/70 mt-3 text-sm">Last updated: January 2026</p>
          </div>
        </section>

        <article className="max-w-4xl mx-auto px-4 sm:px-6 py-10 md:py-14 prose prose-slate max-w-none">
          <p className="text-ink/80 leading-relaxed">
            All payments made on The Pataudi are <strong>non-refundable</strong> unless expressly stated below. Please read this policy carefully before purchasing any plan or badge.
          </p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">1. Subscription plans (buyer credits &amp; seller quotas)</h2>
          <ul className="list-disc pl-6 text-ink/80 space-y-1.5">
            <li>Buyer credit plans (₹199 / ₹249 / ₹399) and seller listing top-ups (₹199 / ₹299 / ₹599) are non-refundable once activated on your account.</li>
            <li>Any credit that has been used to unlock a seller contact is treated as consumed — no refund is possible on used credits.</li>
            <li>Seller listing quota purchases stack on top of your existing quota and never expire until used — they are non-refundable after purchase.</li>
          </ul>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">2. Verified Seller Badge</h2>
          <p className="text-ink/80 leading-relaxed">The Verified Seller Badge (₹249, one-time, lifetime) is <strong>strictly non-refundable</strong> under all circumstances. It is a lifetime add-on with no expiry — please buy only if you are sure.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">3. Exceptions where we do refund</h2>
          <p className="text-ink/80 leading-relaxed">Refunds may be considered only in these cases:</p>
          <ul className="list-disc pl-6 text-ink/80 space-y-1.5 mt-2">
            <li>Technical error from our side (your card was charged but no credits or listing quota were added to your account).</li>
            <li>Duplicate payment for the same order via the payment gateway.</li>
          </ul>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">4. How to request a refund</h2>
          <ol className="list-decimal pl-6 text-ink/80 space-y-1.5">
            <li>Email <a href="mailto:sales@thepataudi.com" className="text-primary underline">sales@thepataudi.com</a> from the address linked to your account.</li>
            <li>Include your Razorpay payment id (starts with <code>pay_</code>) and a short reason.</li>
            <li>Attach a screenshot if a duplicate charge or failure is involved.</li>
          </ol>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">5. Processing</h2>
          <p className="text-ink/80 leading-relaxed">If a refund is approved, the amount is credited back to the original payment method within a reasonable timeframe — typically 5 to 7 business days, depending on your bank or UPI app.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">6. Questions</h2>
          <p className="text-ink/80 leading-relaxed">Anything unclear? Mail <a href="mailto:sales@thepataudi.com" className="text-primary underline">sales@thepataudi.com</a>, call <a href="tel:9467458749" className="text-primary underline">+91 9467458749</a>, or ping us on <a href="https://wa.me/919467458749" target="_blank" rel="noopener noreferrer" className="text-primary underline">WhatsApp</a>.</p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
